module.exports = __webpack_public_path__ + "static/media/alien.041eb7a0.png";